module.exports = __webpack_public_path__ + "img/learn.91be0a35.png";